import { useTypedSearchParams } from '@/hook';
import { VPagination } from '@/package/kiska/src/component/UI/VPagination';
import { useModelingListContext } from '@/provider/modelingList';
import type { ModelingListSearchParams } from '@/type';

const ModelingPagination = () => {
  const { page } = useModelingListContext();
  const { get, set, flush } = useTypedSearchParams<ModelingListSearchParams>();
  const limit = Number(get('modelingLimit'));

  return (
    <VPagination
      currentPage={page.current}
      totalPage={page.total}
      onChange={page => {
        set('modelingOffset', `${(page - 1) * limit}`);
        flush();
      }}
    />
  );
};

export default ModelingPagination;
